<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="margin-left: 20px;margin-bottom: 40px;">

          <button @click="copy">测试公众号复制</button>

        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'



  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {

      }
    },
    mounted() {

    },
    created() {

    },
    methods: {
      copy() {

        let stringToBlob = function(type, str) {
          return new Blob([str], {
            type: type
          });
        }


        try {
          let mp_link = stringToBlob("text/html",
            '<a class="weapp_text_link" data-miniprogram-appid="wxcf87ac6f84c0df3e" data-miniprogram-path="pages/index/index" data-miniprogram-nickname="测试文件1" href="" data-miniprogram-type="text" data-miniprogram-servicetype style="white-space: normal;">测试文件2</a>'
          )

          var tmpdata = [new ClipboardItem({
            "text/html": mp_link
          })];

          navigator.clipboard.write(tmpdata)

        } catch (e) {
          console.error(e)
        }
      }
    },
    watch: {

    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowStyle {
    display: flex;
    justify-content: left;
    padding-left: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/test_copy.vue